import { render, staticRenderFns } from "./profile-item.vue?vue&type=template&id=f45854d2&scoped=true&"
import script from "./profile-item.vue?vue&type=script&lang=js&"
export * from "./profile-item.vue?vue&type=script&lang=js&"
import style0 from "./profile-item.vue?vue&type=style&index=0&id=f45854d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45854d2",
  null
  
)

export default component.exports